module.exports = __webpack_public_path__ + "static/img/m5.510e49b.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/swee/assets/cluster/m5.png
// module id = i75L
// module chunks = 13